import React from 'react';
import { Field } from 'redux-form';
import CustomInput from '../../../../utils/redux-forms-custom-fields/CustomInput';

const Followers = () => {
  return (
    <section className="WhiteListWrapper">
      <div className="followers-requirement">
        <div className="input-group">
          <Field
            name="miniFollowers"
            id="miniFollowers"
            type="text"
            component={CustomInput}
            placeholder="Enter Minimum Follower Requirement"
            onlyNumbers="true"
            customLabel={
              (
                <label className="requirement-label">
                  Minimum Follower Requirement
                  <span className="tooltip">
                    <i className="tooltip-icon fa fa-info-circle" />
                    <div className="tooltip-content">
                      This is set mini followers for Applicants.
                    </div>
                  </span>
                </label>
              )
            }
          />
        </div>
      </div>
    </section>
  );
};

export default Followers;